import { getDocument, GlobalWorkerOptions, version } from "pdfjs-dist";
import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class FilesService {
  private document: Document;

  constructor(@Inject(DOCUMENT) document, private http: HttpClient) {
    this.document = document;
    const pdfWorkerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;
    GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
  }

  public async getPdfPageCount(pdfFile: File): Promise<any> {
    const arrayBuffer = await new Response(pdfFile).arrayBuffer();

    const pdf = await getDocument(arrayBuffer).promise;
    return pdf.numPages;
  }

  getDocxPageCount = async (file: File) => {
    try {
      const formData: FormData = new FormData();
      formData.append("file", file, file["name"]);

      const url = environment.api + "submission-file-page-count";

      const response: any = await this.http.post(url, formData).toPromise();

      return response.numPages;
    } catch (e) {
      // if for any reason we encounter err getting page count, let user upload file
      return 0;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/services/files.service.ts